module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAABCAYAAADn9T9+AAAAFUlEQVQIW2PIzC+6nJlX9B0vBqoBAL/kFjs4Trf0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/minus_1x.png
// module id = 2308
// module chunks = 0